<script lang="ts" setup>
import { ref, inject } from 'vue';
import CollapseFieldset from '@/components/CollapseFieldset.vue';

import type { Ref } from 'vue';

const newPropertyKey = ref('');
const newPropertyValue = ref<unknown>('');
const customProperties = inject('customProperties') as Ref<Map<string, unknown>>;

const createNewProperty = () => {
  if (newPropertyKey.value === '') return;

  if (!customProperties.value.has(newPropertyKey.value)) {
    customProperties.value.set(newPropertyKey.value, newPropertyValue.value);
  }

  newPropertyKey.value = '';
  newPropertyValue.value = '';
};

const updateModelPropertyValue = (event: Event) => {
  const target = event.target as HTMLInputElement;

  newPropertyValue.value = target.value;
};
</script>

<template>
  <CollapseFieldset :enable-collapse="false">
    <template #legend>
      Create New Property
    </template>

    <div class="flex flex-row mb-1 items-center">
      <label class="text-xs mr-2">Name</label>
      <input v-model="newPropertyKey" class="border px-1 py-0.5 text-xs flex-grow" type="text">
    </div>
    <div class="flex flex-row mb-1 items-center">
      <label class="text-xs mr-2">Value</label>
      <textarea class="border px-1 py-0.5 text-xs flex-grow" type="text" :value="(newPropertyValue as string)" @change="updateModelPropertyValue" />
    </div>

    <button type="button" class="bg-lime-600 text-white w-full text-xs p-1" @click="createNewProperty">
      Add New Property
    </button>
  </CollapseFieldset>
</template>
